webpackJsonp([103104352280203],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SEO = __webpack_require__(12);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Page.prototype.render = function render() {
	    var pageSEO = {
	      title: "Legislatie administarre imobile",
	      description: "Am pregatit pentru dvs legislatia in vigoare cu privire la administrarea de imobile.",
	      path: "/legislatie/"
	    };
	    return _react2.default.createElement(
	      "div",
	      { className: "o-page__content" },
	      _react2.default.createElement(_SEO2.default, { pageSEO: pageSEO }),
	      _react2.default.createElement(
	        "div",
	        { className: "c-section-gradient" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container u-pv-20 u-pv-30@tablet u-text-center@tablet" },
	          _react2.default.createElement(
	            "h1",
	            { className: "c-page__heading" },
	            "Legislatie administrare imobile"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "o-container u-pv-20 u-pv-30@tablet u-bg-white" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container o-container--text u-ph-0" },
	          _react2.default.createElement(
	            "p",
	            { className: "u-text-center u-mb-30 u-color-grey-500" },
	            "Nicad Admin Imob va pune la dispozitie resurse utile privind legislatia administrarii imobilelor."
	          ),
	          _react2.default.createElement(
	            "a",
	            { className: "c-resource", href: "/legislatie/OUG_18_2009_reabilitare_termica_cresterea_performantei_energetice_a_blocurilor_de_locuinte.pdf", download: true },
	            _react2.default.createElement(
	              "div",
	              { className: "c-resource__icon" },
	              _react2.default.createElement(
	                "div",
	                { className: "c-resource__icon-extention" },
	                "pdf"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "c-resource__name" },
	              "OUG 18/2009 reabilitare termica cresterea performantei energetice a blocurilor de locuinte"
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { className: "c-resource", href: "/legislatie/Norma metodologica nr 17 din 2009.docx", download: true },
	            _react2.default.createElement(
	              "div",
	              { className: "c-resource__icon" },
	              _react2.default.createElement(
	                "div",
	                { className: "c-resource__icon-extention" },
	                "doc"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "c-resource__name" },
	              "Norma metodologica nr 17 din 2009"
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { className: "c-resource", href: "/legistatie/legea 61 din 27 sept 1991.pdf", download: true },
	            _react2.default.createElement(
	              "div",
	              { className: "c-resource__icon" },
	              _react2.default.createElement(
	                "div",
	                { className: "c-resource__icon-extention" },
	                "pdf"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "c-resource__name" },
	              "LEGE nr. 61 din 27 septembrie 1991"
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { className: "c-resource", href: "/legislatie/LEGEA nr 230.docx", download: true },
	            _react2.default.createElement(
	              "div",
	              { className: "c-resource__icon" },
	              _react2.default.createElement(
	                "div",
	                { className: "c-resource__icon-extention" },
	                "doc"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "c-resource__name" },
	              "LEGEA nr. 230/2007, actualizata 2017, privind infiintarea, organizarea si functionarea asociatiilor de proprietari"
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { className: "c-resource", href: "/legislatie/LEGE nr.114 din 1996 privind locuintele.pdf", download: true },
	            _react2.default.createElement(
	              "div",
	              { className: "c-resource__icon" },
	              _react2.default.createElement(
	                "div",
	                { className: "c-resource__icon-extention" },
	                "pdf"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "c-resource__name" },
	              "LEGE nr. 114 din 11 octombrie 1996 privind locuintele"
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { className: "c-resource", href: "/legislatie/HOTARARE nr.609 din 2007 pentru modificarea art. 2 alin. (2) din Hotararea Guvernului nr. 933 din 2004 .pdf", download: true },
	            _react2.default.createElement(
	              "div",
	              { className: "c-resource__icon" },
	              _react2.default.createElement(
	                "div",
	                { className: "c-resource__icon-extention" },
	                "pdf"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "c-resource__name" },
	              "HOTARARE nr. 609 din 20 iunie 2007"
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { className: "c-resource", href: "/legislatie/HG_1588.pdf", download: true },
	            _react2.default.createElement(
	              "div",
	              { className: "c-resource__icon" },
	              _react2.default.createElement(
	                "div",
	                { className: "c-resource__icon-extention" },
	                "pdf"
	              )
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "c-resource__name" },
	              "HOTARA\u0302RE Nr. 1588 din 19 decembrie 2007 "
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Page;
	}(_react2.default.Component);
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-legislatie-js-b3ad1ed13c613c3b8528.js